import { useScrollReveal } from '../hooks/useScrollReveal';
import { SEOHead } from '../components/SEOHead';

export const TermsPage = () => {
  const pageRef = useScrollReveal();
  const effectiveDate = 'June 16, 2026';

  return (
    <main className="pt-24" ref={pageRef}>
      <SEOHead path="/terms" />
      <section className="py-14 md:py-20 bg-cream">
        <div className="container-padding">
          <div className="max-w-3xl mx-auto">
            <span className="reveal overline-text mb-4 block">Legal</span>
            <h1 className="reveal reveal-delay-1 text-3xl md:text-4xl lg:text-5xl font-medium mb-4" style={{ fontFamily: "'Playfair Display', Georgia, serif" }}>
              Terms and Conditions
            </h1>
            <p className="reveal reveal-delay-2 text-sm text-[#9A9A9A]">Effective Date: {effectiveDate}</p>
          </div>
        </div>
      </section>

      <section className="py-14 md:py-20">
        <div className="container-padding">
          <div className="max-w-3xl mx-auto prose prose-lg prose-pink prose-headings:font-semibold prose-headings:text-[#2A2A2A] prose-h2:text-xl prose-h2:mt-10 prose-h2:mb-4 prose-h3:text-lg prose-h3:mt-8 prose-h3:mb-3 prose-p:text-[#4A4A4A] prose-p:leading-relaxed prose-p:mb-4 prose-li:text-[#4A4A4A] prose-ul:my-4 prose-li:my-1 prose-a:text-[#E84993] prose-strong:text-[#2A2A2A]" data-testid="terms-content">

            <h2>1. Acceptance of Terms</h2>
            <p>
              By accessing and using <strong>iamnatashasimone.com</strong> (the "Site"), operated by Yellow Mango Production ("we," "us," or "our"),
              you agree to be bound by these Terms and Conditions ("Terms"). If you do not agree to these Terms, please do not use the Site.
            </p>

            <h2>2. Use of the Site</h2>
            <p>You agree to use the Site only for lawful purposes and in a manner that does not:</p>
            <ul>
              <li>Violate any applicable federal, state, or local law or regulation</li>
              <li>Infringe upon the rights of others</li>
              <li>Interfere with or disrupt the Site or servers connected to the Site</li>
              <li>Attempt to gain unauthorized access to any part of the Site</li>
              <li>Collect or harvest any personally identifiable information from the Site</li>
              <li>Use the Site for any commercial purpose without our express written consent</li>
            </ul>

            <h2>3. Intellectual Property</h2>
            <p>
              All content on this Site — including but not limited to text, graphics, logos, images, audio, video, software,
              the "Natasha Simone" name, "Diverse Intelligence Systems" (DIS), "The Beauty of You," "Red Carpet Girl," and all related
              trademarks, service marks, and trade names — is the exclusive property of Yellow Mango Production or its licensors
              and is protected by United States and international copyright, trademark, and other intellectual property laws.
            </p>
            <p>
              You may not reproduce, distribute, modify, create derivative works of, publicly display, publicly perform,
              republish, download, store, or transmit any of the material on the Site without our prior written consent, except for:
            </p>
            <ul>
              <li>Temporary storage in RAM incidental to your accessing and viewing the content</li>
              <li>Storing files that are automatically cached by your web browser for display enhancement</li>
              <li>Printing or downloading one copy of a reasonable number of pages for your own personal, non-commercial use</li>
            </ul>

            <h2>4. User-Submitted Content</h2>
            <p>
              When you submit information through the Site (e.g., contact forms, inquiries, event registrations), you grant us
              a non-exclusive, royalty-free license to use, store, and process that information for the purpose of
              responding to your inquiry and providing our services. Your submissions are governed by our Privacy Policy.
            </p>

            <h2>5. Products and Services</h2>
            <p>
              We may offer products (such as books) and services (such as coaching, workshops, and speaking engagements) through the Site.
              All descriptions, pricing, and availability are subject to change without notice.
              We reserve the right to refuse or cancel any order at our discretion.
            </p>
            <p>
              Payment processing is handled by third-party providers (e.g., Stripe). By making a purchase,
              you agree to the terms and conditions of the applicable payment processor.
            </p>

            <h2>6. Events and Programs</h2>
            <p>
              Registration for events and programs may be subject to additional terms, including cancellation policies,
              liability waivers, and codes of conduct. These terms will be provided at the time of registration.
              We reserve the right to modify event details, including dates, locations, and speakers, at our discretion.
            </p>

            <h2>7. Disclaimer of Warranties</h2>
            <p>
              THE SITE AND ALL CONTENT, MATERIALS, AND SERVICES PROVIDED THROUGH THE SITE ARE PROVIDED ON AN "AS IS" AND
              "AS AVAILABLE" BASIS WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED. TO THE FULLEST EXTENT
              PERMITTED BY LAW, WE DISCLAIM ALL WARRANTIES, INCLUDING BUT NOT LIMITED TO IMPLIED WARRANTIES OF
              MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.
            </p>
            <p>
              The information provided on this Site, including coaching advice, business strategies, and personal development content,
              is for general informational purposes only and does not constitute professional advice. Results may vary and are not guaranteed.
            </p>

            <h2>8. Limitation of Liability</h2>
            <p>
              TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, YELLOW MANGO PRODUCTION, ITS OFFICERS, DIRECTORS, EMPLOYEES,
              AND AGENTS SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES,
              INCLUDING BUT NOT LIMITED TO LOSS OF PROFITS, DATA, USE, OR GOODWILL, ARISING OUT OF OR RELATED TO YOUR USE
              OF THE SITE, WHETHER BASED ON WARRANTY, CONTRACT, TORT (INCLUDING NEGLIGENCE), OR ANY OTHER LEGAL THEORY.
            </p>
            <p>
              IN NO EVENT SHALL OUR TOTAL LIABILITY TO YOU EXCEED THE AMOUNT YOU HAVE PAID TO US IN THE TWELVE (12) MONTHS
              PRECEDING THE EVENT GIVING RISE TO THE LIABILITY, OR ONE HUNDRED DOLLARS ($100), WHICHEVER IS GREATER.
            </p>

            <h2>9. Indemnification</h2>
            <p>
              You agree to defend, indemnify, and hold harmless Yellow Mango Production and its officers, directors, employees,
              and agents from and against any claims, liabilities, damages, judgments, awards, losses, costs, expenses,
              or fees (including reasonable attorneys' fees) arising out of or relating to your violation of these Terms
              or your use of the Site.
            </p>

            <h2>10. Third-Party Links</h2>
            <p>
              The Site may contain links to third-party websites or services that are not owned or controlled by us.
              We have no control over, and assume no responsibility for, the content, privacy policies, or practices
              of any third-party websites. You acknowledge and agree that we are not liable for any damage or loss
              caused by or in connection with the use of any such content, goods, or services.
            </p>

            <h2>11. Governing Law and Jurisdiction</h2>
            <p>
              These Terms shall be governed by and construed in accordance with the laws of the State of Florida,
              United States, without regard to its conflict of law provisions.
              Any legal suit, action, or proceeding arising out of or related to these Terms shall be instituted
              exclusively in the federal or state courts located in Hillsborough County, Florida.
              You waive any and all objections to the exercise of jurisdiction over you by such courts.
            </p>

            <h2>12. Changes to These Terms</h2>
            <p>
              We reserve the right to modify these Terms at any time. When we do, we will revise the "Effective Date"
              at the top of this page. Your continued use of the Site after any such changes constitutes your acceptance
              of the new Terms.
            </p>

            <h2>13. Severability</h2>
            <p>
              If any provision of these Terms is held to be invalid or unenforceable, the remaining provisions
              shall continue in full force and effect.
            </p>

            <h2>14. Contact Us</h2>
            <p>If you have any questions about these Terms, please contact us:</p>
            <ul>
              <li><strong>Email:</strong> <a href="mailto:hello@iamnatashasimone.com" className="text-[#E84993]">hello@iamnatashasimone.com</a></li>
              <li><strong>Address:</strong> Yellow Mango Production, 401 N. Ashley Dr., Suite #173011, Tampa, Florida 33602</li>
            </ul>

          </div>
        </div>
      </section>
    </main>
  );
};

export default TermsPage;
